import React from "react"
import {chakra, Box, Flex} from "@chakra-ui/react"

const GoogleAppLink = () => {
    return <Box>
        <Flex as="a" direction="column" display="flex" alignItems="center" href='https://play.google.com/store/apps/details?id=fm.touhou.touhoufm&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <chakra.img
                flex="0 0 auto"
                height="6em"
                alt='Get it on Google Play'
                src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
        </Flex>
    </Box>
}

export default GoogleAppLink